import { UAParser } from 'ua-parser-js';
import { getUiVersion, strInfoAboutDevice } from 'utils';
import { createRequestSupportForm, setErrorSupportForm, setResponseSupportForm, } from 'shared/support.request/model/index';
import { getAPIErrorMessage } from 'api';
export const createIssue = (issue) => async (dispatch, getState, { api }) => {
    const ui_version = getUiVersion();
    const { device, os } = new UAParser().getResult();
    const is_os = os.name && os.version;
    const device_details = `Модель - ${device.model}, Тип - ${device.type}`;
    const os_details = `ОС - ${os.name}, Версия - ${os.version}`;
    let departure_device = is_os ? os_details : device_details;
    const device_info = strInfoAboutDevice();
    if (device_info) {
        departure_device = device_info;
    }
    const new_user = {
        ...issue,
        ui_version,
        departure_device,
    };
    dispatch(createRequestSupportForm());
    try {
        const response = await api.create_issue_from_support(new_user);
        dispatch(setResponseSupportForm(response.id.toString()));
    }
    catch (error) {
        dispatch(setErrorSupportForm(getAPIErrorMessage(error, 'Не удалось отправить запрос на сервер Okdesk')));
    }
};
